export default "__VITE_ASSET__DaIxYkvR__"